import React from 'react';
import {
  DialogMessageRenderer,
  DialogMessageText,
  InteractiveMessageLayout,
  MessageDate,
  MessageFooter,
  TextMessageLayout,
  useCurrentDialogMember,
  useIsOutgoing,
} from '@cp/entities/dialog';
import { MessageType } from '@common/model/dialog/message/messageType';
import { Button } from '@cp/ds/src/components/button';
import { promocodeApi } from '@cp/entities/promocode';
import { PromocodeUsageStatus } from '@common/model/billing/promocode';
import { useStartBillingSubscription } from 'src/features/billing';

export const PromocodeMessageRenderer: DialogMessageRenderer<MessageType.Promocode> = (props) => {
  const { message, dialogId, isPreview } = props;
  const { id } = message.payload;
  const currentMember = useCurrentDialogMember({ dialogId });
  const outgoing = useIsOutgoing(message);
  const { data, isLoading } = promocodeApi.endpoints.getPromocodeUsage.useQuery({ id });
  const usage = data?.items.find((u) => u.acceptorId === currentMember?.entityId);
  const stat = outgoing || isLoading || usage?.status === PromocodeUsageStatus.Wasted;
  const [startSubscription, { isLoading: subscriptionLoading }] = useStartBillingSubscription();

  if (isPreview) {
    return <DialogMessageText>Промокод {id}</DialogMessageText>;
  }

  return stat ? (
    <TextMessageLayout outgoing={outgoing}>
      <DialogMessageText>
        {outgoing ? 'Вы отправили' : 'Вы получили'} промокод {id}
      </DialogMessageText>
      <MessageFooter>
        <MessageDate message={message} />
      </MessageFooter>
    </TextMessageLayout>
  ) : (
    <InteractiveMessageLayout>
      <DialogMessageText>
        Вы получили промокод {id}
        <br />
        Активировать его сейчас?
      </DialogMessageText>
      <Button color="gray" disabled={subscriptionLoading} onClick={startSubscription} size="extraSmall" variant="primary">
        Aктивировать
      </Button>
    </InteractiveMessageLayout>
  );
};
